import { render, staticRenderFns } from "./concubineDetails.vue?vue&type=template&id=0f471a13&scoped=true"
import script from "./concubineDetails.vue?vue&type=script&lang=js"
export * from "./concubineDetails.vue?vue&type=script&lang=js"
import style0 from "./concubineDetails.vue?vue&type=style&index=0&id=0f471a13&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f471a13",
  null
  
)

export default component.exports